export default __webpack_public_path__ + "static/16-e41843f634ede28f3b04fa5b4d29d484.jpg";